<template>
  <div class="BillDetails">
    <div class="BillDetails-background">
      <div class="NewCape-AppTitle">
        <img src="../../public/obraoag/NewCapeReturn.png" alt="" @click="BackLevel()">
        账单详情
      </div>
      <div class="BillDetails-name">{{this.bitrpe}}</div>
      <div class="BillDetails-number">{{this.birant}}</div>
      <div class="BillDetails-state">{{this.bisaet}}</div>
      <div class="BillDetails-record">
        <span class="BillDetails-record-left">转出卡号</span>
        <span class="BillDetails-record-right">{{this.bisrmb}}</span>
      </div>
      <div class="BillDetails-record">
        <span class="BillDetails-record-left">支付金额</span>
        <span class="BillDetails-record-right">{{this.birant}}</span>
      </div>
      <div class="BillDetails-record">
        <span class="BillDetails-record-left">交易类型</span>
        <span class="BillDetails-record-right">{{this.bisaet}}</span>
      </div>
      <div class="BillDetails-record">
        <span class="BillDetails-record-left">交易时间</span>
        <span class="BillDetails-record-right">{{this.bitime}}</span>
      </div>
      <div class="BillDetails-record">
        <span class="BillDetails-record-left">流水号</span>
        <span class="BillDetails-record-right">{{this.bisebr}}</span>
      </div>
    </div>
    <TextTips></TextTips>
  </div>
</template>

<script>
import "./obraojs/rem"
export default {
  data () {
    return{
      bitrpe: '',
      birant: '',
      bisaet: '',
      bisrmb: '',
      bitime: '',
      bisebr: ''
    }
  },
  created () {
    // 接收从账单传过来的账单详情
    this.bitrpe = this.$route.query.mytrpe;
    this.birant = this.$route.query.myrant;
    this.bisaet = this.$route.query.mysaet;
    this.bisrmb = this.$route.query.mysrmb;
    this.bitime = this.$route.query.mytime;
    this.bisebr = this.$route.query.mysebr;
  },
  mounted () {

  },
  methods: {
    // 返回上一层
    BackLevel(){
      this.$router.push({name: 'MyBill',query: {catfbr: this.bisrmb}});
    }
  }
}
</script>

<style scoped>
  @import "obraocs/BillDetails.css";
</style>